import { Navigate, useNavigate } from "react-router-dom";
import React, { FormEvent, useCallback, useContext, useState } from "react";
import { signIn } from "../../firebase";
import { AuthContext } from "./auth-provider";
import { ErrorToast } from "./error-toast";
import { AuthError } from "@firebase/auth";

export const Login = () => {
  const user = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSignIn = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      signIn(email, password).catch((error: AuthError) => {
        setError(error.code);
      });
    },
    [email, password]
  );

  if (user && user?.emailVerified) {
    return <Navigate to={"/"} />;
  } else if (user && !user?.emailVerified) {
    return <Navigate to={"/verify-email"} />;
  } else {
    return (
      <div className="food xs:mt-16 xs:rounded shadow-xl mx-auto p-4 xs:max-w-sm">
        {error ? (
          <ErrorToast message={error} onDismiss={() => setError(null)} />
        ) : null}
        <form onSubmit={handleSignIn}>
          <div className="w-full flex justify-center items-center">
            <h1 className="text-xl font-bold text-white mb-6">Inloggen</h1>
          </div>
          <div className="mb-6">
            <label className="box-input-label mb-2" htmlFor="form-email">
              Email
            </label>
            <input
              className="box-input mb-3"
              id="form-email"
              type="text"
              value={email}
              onChange={(event) => {
                setEmail(event.currentTarget.value);
              }}
              placeholder="jouw@email.nl"
            />
          </div>
          <div className="mb-6">
            <label className="box-input-label mb-2" htmlFor="form-password">
              Wachtwoord
            </label>
            <input
              className="box-input mb-3"
              id="form-password"
              type="password"
              value={password}
              onChange={(event) => {
                setPassword(event.currentTarget.value);
              }}
              placeholder="********"
            />
          </div>

          <button className="btn-primary mb-12">
            <i className="fa fa-sign-in-alt mr-2 fa-2x" />
            <span>Inloggen</span>
          </button>
        </form>

        <button
          onClick={() => {
            navigate("/signup");
          }}
          className="btn-secondary mb-6"
        >
          <i className="fa fa-user mr-2 fa-2x" />
          <span>Naar registreren</span>
        </button>

        <button
          onClick={() => {
            navigate("/reset-password");
          }}
          className="btn-secondary mb-6"
        >
          <i className="fa fa-key mr-2 fa-2x" />
          <span>Wachtwoord herstellen</span>
        </button>
      </div>
    );
  }
};
